import axios from 'axios'
import supportedLocales from './../supported-locales'

export default {
  methods: {
    isDacia: () => process.env.VUE_APP_THEME === 'dacia',
    priceFormat(price) {
      let p = parseFloat(price);
      if (p % 1 !== 0) p = p.toFixed(2);
      return p.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    },
    getQueryStringParams(paramName) {
			const params = {}
			const queryString = window.location.search.split('?')
			if (queryString.length > 1) {
				const pairs = queryString[1].split('&')
				for (let i in pairs) {
					const param = pairs[i].split('=')
					params[param[0]] = param[1]
				}
			}
			if (paramName) return params[paramName] ? params[paramName] : ''
			return params
		},
    getSupportedLocales() {
      let annotatedLocales = []
      for (const code of Object.keys(supportedLocales)) {
        annotatedLocales.push({
          code,
          label: supportedLocales[code]
        })
      }
      return annotatedLocales
    }
  }
}
